export default __webpack_public_path__ + "static/media/10.6a4b59ed.jpg";